import { useEffect } from "react";
import Menubar from "../Menubar";
import GCWHubspot from "./GCWHubspot";
import {
    Trans,
    useTranslation,
    language,
    useI18next,
} from "gatsby-plugin-react-i18next";

const ContestGuidelines = () => {
    const { t, i18n, changeLanguage } = useI18next();

    return (
        <>
            <Menubar
                whatsInIt={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#whatsinit"
                }
                howToJoin={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#howtojoin"
                }
                joinNow={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#gcwHubspotForm"
                }
            />
            <section className="bannerAreaN greyBackgroundN BannerDeatils">
                <div className="detailsPageSection cg-bg-res">
                    <img
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
                        alt="corporate wellness"
                        className="img-responsive"
                    />
                </div>
                <div className="row cg-logo">
                    <div className="col-12 col-lg-6 ">
                        <div className="container w-100 h-100 d-flex justify-content-center align-items-center">
                            <h1 className="text-light section-heading text-center">
                                Contest Guidelines
                            </h1>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <div className="container row justify-content-end">
                            <div>
                                <img
                                    className="col-10 col-lg-10"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1728368929/VantageFit/2024/walkathon_logo_2024-02_1.png"
                                    alt="GCW"
                                />
                                <div className="col-10 text-right gcwdate1 text-white">
                                    12<sup>th</sup> Nov - 10<sup>th</sup> Dec
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row justify-content-center cg-logo">
                    <img
                        className="col-6 col-md-3"
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1727951458/VantageFit/2024/gcw/GCW-Logo.png"
                        alt="GCW"
                    />
                </div>
                <div className="BannerContent singleHeading cg-heading">
                    <div className="headingBannerM container customCampaignContainer text-left">
                        <div className="row">
                            <div className="text-center col-lg-12 col-xs-12 col-md-12 col-sm-12">
                                <h1>Contest Guidelines</h1>
                            </div>
                        </div>
                    </div>
                </div> */}
            </section>
            <section className="col-12 py-4 py-lg-5 home-bg-1">
                <div className="container">
                    <h2 className="section-heading text-center text-md-left text-light">
                        We're glad that you are interested in making a
                        difference by engaging your employees in the Global
                        Corporate Virtual Walkathon.
                    </h2>
                    <p className="section-para font-weight-normal text-light text-center text-md-left mt-5">
                        We appreciate your participation in the event and are
                        delighted that your prioritize health and wellness in
                        your organization.
                    </p>
                    <p className="section-para font-weight-normal text-light">
                        To be a part of this virtual walkathon, all you have to
                        do is follow the given instructions and you will be good
                        to go.
                    </p>
                </div>
            </section>
            <section className="col-12 d-flex justify-content-start py-5 home-bg-1">
                <div className="d-flex flex-column flex-lg-row container py-lg-4">
                    <div
                        className="col-12 col-lg-3 d-lg-flex align-items-start pl-lg-5 d-none"
                        style={{
                            borderRight: "1px solid #62646a",
                        }}
                    >
                        <h2 className="section-heading text-left text-light">
                            Table of <br /> Contents
                        </h2>
                    </div>
                    <div className="col-12 col-lg-9 d-flex flex-column align-items-start justify-content-center pl-lg-5 text-center mt-5 mt-lg-0">
                        <h2 className="subSectionTitle-left font-weight-bold d-flex d-lg-none pb-3 text-light">
                            Table of Contents
                        </h2>
                        <div className="row d-none d-lg-flex ">
                            <div className="col-6">
                                <ul className="cg-toc-lists">
                                    <li>
                                        <a
                                            href="#vfit"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            What is Vantage Fit?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#whocan"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Who can participate?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#track"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to start the contest?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#sec5"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to track your progress?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#prizes"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            What are the prizes for this
                                            contest?
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-6">
                                <ul className="cg-toc-lists">
                                    <li>
                                        <a
                                            href="#redeem"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to redeem your reward?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#t&c"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Terms & Conditions
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#PrivacyPolicy"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Privacy Policy
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="#Jurisdiction"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Governing Jurisdiction
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#Contest"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Contest Timings
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="row d-flex d-lg-none">
                            <div className="col-12 ">
                                <ul className="cg-toc-lists">
                                    <li>
                                        <a
                                            href="#vfit"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            What is Vantage Fit?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#whocan"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Who can participate?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#howTostart"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to start the contest?
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="#track"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to track your progress?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#prizes"
                                            className="text-light  py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            What are the prizes for this
                                            contest?
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#redeem"
                                            className="text-light sub-para-link-left py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            How to redeem your reward?
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="#t&c"
                                            className="text-light sub-para-link-left py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Terms & Conditions
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#PrivacyPolicy"
                                            className="text-light sub-para-link-left py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Privacy Policy
                                        </a>
                                    </li>

                                    <li>
                                        <a
                                            href="#Jurisdiction"
                                            className="text-light sub-para-link-left py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Governing Jurisdiction
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#Contest"
                                            className="text-light sub-para-link-left py-1 py-lg-2 my-1 my-lg-2 w-100"
                                        >
                                            Contest Timings
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="col-12 py-5">
                <div className="container py-lg-4 pl-lg-4" id="vfit">
                    <h2 className="pl-lg-2 subSectionTitle-left">
                        What is Vantage Fit?
                    </h2>
                    <p className="sub-para-left pl-lg-2 font-weight-normal">
                        Vantage Fit is the flagship product of Vantage Circle, a
                        company that specializes in employee engagement,
                        rewards, fitness and wellness solutions. It is an
                        all-in-one corporate health and fitness product. The
                        parent company of Vantage Circle is Bargain Technologies
                        Private Limited.
                    </p>
                    <div
                        className="px-md-5 ml-lg-2 rounded"
                        style={{
                            backgroundColor: "#d2f3f0",
                            border: "1px solid #c1f5e3",
                        }}
                    >
                        <p className="mr-auto sub-para font-weight-normal text-left">
                            <i>
                                <strong>Please Note:</strong> By participating
                                in this global corporate virtual walkathon, you
                                automatically comply with all the guidelines,
                                privacy policy, terms, and conditions, and all
                                other points listed below.
                            </i>
                        </p>
                    </div>
                </div>

                <div className="container py-lg-4 pl-lg-4" id="whocan">
                    <h2 className="pl-lg-2 subSectionTitle-left">
                        Who can participate ?
                    </h2>
                    <p className="mr-auto sub-para font-weight-normal">
                        To participate in this contest, you should have a
                        minimum of 25 team members from your organization
                        participating. The maximum number of participants is 100
                        members per organization for the free plan and 500
                        members for the paid plan. Companies with more than 500
                        employees will be charged on a pro-rata basis.
                    </p>
                    <p className="mr-auto sub-para font-weight-normal">
                        The bigger your team, the better your chances of
                        winning.
                    </p>
                </div>

                <div className="container p-0 py-lg-5 pl-lg-4" id="howTostart">
                    <h2 className=" pl-lg-2 subSectionTitle-left">
                        How to start the contest?
                    </h2>
                    <div className="container">
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    1
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center font-weight-normal text-lg-left sub-para">
                                    Email us at{" "}
                                    <a
                                        href="mailto:globalwalkathon@vantagecircle.com"
                                        className="text-red"
                                    >
                                        globalwalkathon@vantagecircle.com
                                    </a>{" "}
                                    and schedule a call with our support
                                    executive to learn all about the contest.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    2
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    Create teams of 25 employees per team.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    3
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    Send us a list of your team members by the
                                    last time of registration given in the
                                    Global Time Chart.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    4
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    Once your team is registered, a confirmation
                                    mail will be sent from us to all the team
                                    members that will contain contest
                                    participation instructions, guidelines, and
                                    terms and conditions.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    5
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    A participation acknowledgment mail will
                                    also be sent to your organization's POC on
                                    30th October, 2024.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    6
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    Participants will have to download the
                                    Vantage Fit App, available in both Google
                                    Play Store and Apple App store which will be
                                    used to track steps in the contest. Seamless
                                    integration is also available for a wide
                                    variety of wearable devices.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    7
                                </div>
                                <div className="dashed-line"></div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    An email will be sent on 12th November, 2024
                                    to announce the start of the contest.
                                </p>
                            </div>
                        </div>
                        <div className="row align-items-center mt-4">
                            <div className="col-12 col-lg-1 d-flex flex-column align-items-center position-relative">
                                <div
                                    className="circle-number d-flex justify-content-center align-items-center text-light font-weight-bold"
                                    style={{
                                        backgroundColor: "#4acaba",
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                    }}
                                >
                                    8
                                </div>
                            </div>
                            <div className="col-12 col-lg-10">
                                <p className="text-center text-lg-left sub-para font-weight-normal">
                                    Walk at your convenience from 12th November,
                                    2024 to 10th December, 2024.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container py-5 pl-lg-1" id="track">
                    <h2 className="subSectionTitle-left">
                        How to track your progress?
                    </h2>
                    <p className="sub-para-left font-weight-normal pl-lg-1">
                        After the contest is live, you can track your progress
                        on the Vantage Fit app's leaderboard and the website.
                        The link to the leaderboard page will be sent to you via
                        email once the contest kicks off.
                    </p>
                </div>

                <div className="container py-lg-5 pl-lg-1" id="prizes">
                    <h2 className="pl-lg-1 subSectionTitle-left">
                        What are the rewards for this contest?
                    </h2>
                    <p className="sub-para-left pl-lg-1 font-weight-normal">
                        <strong>
                            By taking part and completing the contest, you can
                            win amazing prizes -
                        </strong>
                    </p>
                    <p className="sub-para-left pl-lg-1 font-weight-normal">
                        <b>For Free Participants -</b>
                    </p>
                    <ol className="font-weight-normal">
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                {" "}
                                Participation Certificates{" "}
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                40% off on Annual Subscription of the Vantage
                                Fit Platform{" "}
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                25% off on One-Time Subscription of the Vantage
                                Fit Platform{" "}
                            </p>
                        </li>
                    </ol>
                    <p className="sub-para-left pl-lg-1 font-weight-normal">
                        <b>For Paid Participants -</b>
                    </p>
                    <ol className="font-weight-normal">
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Prizes for Top 3 Teams (To be disclosed)
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                {" "}
                                Participation Certificates{" "}
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                $250 Waiver on the Platform Setup Cost of the
                                Vantage Fit Platform
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                50% off on Annual Subscription of the Vantage
                                Fit Platform{" "}
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                30% off on One-Time Subscription of the Vantage
                                Fit Platform{" "}
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Participation Engagement Report after the
                                virtual walkathon is over
                            </p>
                        </li>
                    </ol>
                </div>

                <div className="container py-5 pl-lg-1" id="redeem">
                    <h2 className="pl-lg-2 subSectionTitle-left">
                        How to redeem your reward? (Paid Only)
                    </h2>
                    <p className="sub-para-left pl-lg-1 font-weight-normal">
                        All winners will be rewarded through Amazon gift cards
                        via email. Users will have a validity period of 1 year
                        to redeem the amount they received.
                    </p>
                </div>

                <div className="container py-lg-5 p-0 pl-lg-1" id="t&c">
                    <h2 className="pl-lg-2 subSectionTitle-left">
                        Terms & Conditions
                    </h2>
                    <ul>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Your organization's name and logo will be
                                displayed on the leaderboard on the website and
                                social media for contest announcements. The
                                winners' names and logos will be displayed on
                                the website, email and PR announcements, and
                                social media.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                There are two participation plans for this
                                contest i.e., Free and Paid ($250). Please refer
                                to this page for more details regarding the
                                plans.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Before participating in the contest, please
                                consult a medical professional if you have any
                                existing health problems or complications.
                                Vantage Circle (Bargain Technologies) is not
                                liable for any injuries or accidents that may
                                take place during the contest.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Please adhere to all the Covid-19 pandemic
                                precautions, rules, and regulations laid down by
                                your government, WHO, and the CDC.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Participants found cheating or using unfair
                                means to increase their step counts will be
                                disqualified as our system will be analyzing any
                                manipulated data.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Registration will be done on a first-come,
                                first-serve basis, and we have all liberty to
                                cancel the registration if required.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Any queries and grievances can be addressed at{" "}
                                <a
                                    className="text-red"
                                    href="mailto:support@vantagecircle.com"
                                >
                                    support@vantagecircle.com
                                </a>
                                . Please contact us via email in case of any
                                instructions or restrictions regarding branding.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Vantage Circle (Bargain Technologies Pvt. Ltd.)
                                has all rights to dismiss the contest or
                                eliminate any participant company in case of any
                                unfavorable or unprecedented circumstance.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Any Gift Cards sent are valid for 1 year
                                starting from the date of receiving them.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                While we have taken every precaution to ensure
                                that all the information provided is accurate
                                and current, errors may occur. Vantage Circle
                                isn't liable for any misinterpretation or
                                negligence on your part.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Kindly refer to the registration, contest start
                                and end dates, and the timetable below as per
                                your location time zone. And feel free to
                                convert to your time zone according to the
                                Greenwich Mean Time (GMT) if your timezone is
                                not listed below.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                You can register in the contest only with your
                                email id provided by the company & thus, using
                                any other(or personal) email id will not be
                                considered.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Suppose simultaneous entries appear from
                                different managers for the same company. In that
                                case, we will prioritize bulk registration
                                first, followed by individual registration based
                                on a first-come, first-served irrespective of
                                managers' location or employees' numbers. The
                                overall participation number from a company
                                should vary within 5-100 only.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Companies with more than 25 employees can
                                participate by creating multiple teams, such as
                                Company Team A, Company Team B, and so on. In
                                such a case, only the winning team of a maximum
                                of 25 participants will be rewarded. Also, steps
                                will be counted as individual teams for each
                                company, not the overall company. Teams will be
                                shown as Company Team A, Company Team B, and
                                likewise on the leaderboard, competing as
                                separate teams. However, any discounted offers
                                on subscriptions to the Vantage Fit platform
                                will be redeemable by the company as a whole and
                                not individual teams.
                            </p>
                        </li>
                    </ul>
                </div>

                <div className="container py-5 p-0 pl-lg-1" id="PrivacyPolicy">
                    <h2 className="pl-lg-1 subSectionTitle-left">
                        Privacy Policy
                    </h2>
                    <ul>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                The data/information collected will neither be
                                misused nor it will be shared with any third
                                party, other than our subsidiaries and business
                                partners.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                The information/data will be stored in our
                                database in a secured cloud based server which
                                has been reliable to more than a million users.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                No unnecessary emails other than informative
                                communications will be sent by Vantage Circle
                                (Bargain Technologies Pvt. Ltd.).
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Vantage Fit tracks your motion and activity data
                                by connecting to your smartphone's sensor or any
                                wearables if connected.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Vantage Fit tracks the steps of the participants
                                only for the purpose of the contest to reward
                                participants accordingly.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Vantage Fit does not track your location when
                                you are not in a GPS based workout. It only
                                tracks your location when you are in a GPS based
                                workout, outdoor run, jogging, walking or
                                cycling.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Please reach out to us if you have any concern{" "}
                                <a
                                    className="text-red"
                                    href="mailto:support@vantagecircle.com"
                                >
                                    support@vantagecircle.com
                                </a>
                                .
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                The Services we offer may change from time to
                                time. As a result, at times it may be necessary
                                for us to make changes to this Privacy Policy.
                                Accordingly, we reserve the right to update or
                                modify this Privacy Policy at any time and from
                                time to time without prior notice.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                In no event shall we, nor our directors,
                                employees, agents, partners, suppliers or
                                content providers, be liable under contract,
                                tort, strict liability, negligence or any other
                                legal or equitable theory with respect to the
                                services (i) for any loss of profits, data loss,
                                loss of use, business interruption, cost of
                                procurement of substitute goods or services, or
                                other economic losses, or special, indirect,
                                incidental, punitive, compensatory or
                                consequential damages of any kind whatsoever,
                                substitute goods or services (however arising),
                                (ii) for any bugs, viruses, trojan horses, or
                                the like (regardless of the source of
                                origination), or (iii) for any direct damages in
                                excess of (in the aggregate) of fees paid to us
                                for the particular services during the
                                immediately previous one month period, even if
                                vantage circle had been advised of, knew, or
                                should have known, of the possibility thereof.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                Your sole and exclusive right and remedy in case
                                of dissatisfaction with the services or any
                                other grievance shall be your termination and
                                discontinuation of access to or use of the
                                services.
                            </p>
                        </li>
                        <li>
                            <p className="sub-para-left pl-lg-1 font-weight-normal">
                                In addition, you agree that vantage circle is
                                not responsible for any data compiled by our
                                services and that vantage circle will not be
                                liable, in any manner, as a result of your
                                exposure to any defamatory, libelous,
                                threatening, harassing, obscene or otherwise
                                unlawful content or data. In some jurisdictions
                                limit or prohibit the foregoing limitations, and
                                in such jurisdictions the foregoing limitations
                                shall be applied to the maximum extent permitted
                                by law.
                            </p>
                        </li>
                    </ul>
                </div>

                <div className="container py-5 pl-lg-1" id="Jurisdiction">
                    <h2 className="subSectionTitle-left">
                        Government Jurisdiction
                    </h2>
                    <p className="sub-para-left pl-lg-1 font-weight-normal">
                        Use of this service shall be governed by and constructed
                        in accordance with Indian law. Any dispute(s) arising in
                        connection with the use of this Website or App is
                        subject to the exclusive jurisdiction of Delhi.
                    </p>

                    <div
                        className="my-5 py-4 rounded"
                        id="Contest"
                        style={{ backgroundColor: "#d2f3f0" }}
                    >
                        <div className="d-flex flex-column flex-lg-row py-4">
                            <div className="mx-auto text-center">
                                <h2 className="subSectionTitle-left text-center">
                                    Contest Start
                                </h2>
                                <p className="font-weight-normal">
                                    00:00hrs Midnight, 12th November, 2024 (All
                                    time zones)
                                </p>
                            </div>
                            <div className="mx-auto text-center">
                                <h2 className="text-center subSectionTitle-left">
                                    Contest End
                                </h2>
                                <p className="font-weight-normal">
                                    00:00hrs Midnight, 10th December, 2024 (All
                                    time zones)
                                </p>
                            </div>
                        </div>
                        <div className="px-md-5 ml-lg-2">
                            <p className="mr-auto mx-2  sub-para cg-note pl-4 text-left">
                                <i>
                                    {" "}
                                    <strong>Please Note:</strong> By
                                    participating in this global corporate
                                    virtual walkathon, you automatically comply
                                    with all the guidelines, privacy policy,
                                    terms, and conditions, and all other points
                                    listed below.
                                </i>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="section-heading text-center no-br">
                            <Trans>
                                Unlock the power of a happier <br />& healthier
                                workforce
                            </Trans>
                        </h2>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a
                                href={t(`/request-demo/`)}
                                className="vfitcompanycta arrowbtn-img"
                            >
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default ContestGuidelines;
